export const ASSET_TYPE = ['container', 'chassis', 'truck'] as const

export type AssetType = (typeof ASSET_TYPE)[number]

const assetSet = new Set<string>(ASSET_TYPE)
export const isAssetType = (unknown: unknown): unknown is AssetType =>
    typeof unknown === 'string' && assetSet.has(unknown)

export const ALERT_METHOD_KEYS = ['email', 'sms'] as const
const METHOD_KEYS: string[] = [...ALERT_METHOD_KEYS]
export const isAlertMethod = (val: unknown): val is string => {
    if (typeof val !== 'string') return false
    return METHOD_KEYS.includes(val)
}

export type AlertMethod = string

export const ALERT_TYPE_KEYS = [
    'assetArrivalId',
    'assetArrivalTime',
    'assetDepartureTime',
    'assetMaxDwellTime',
] as const

const ALERT_TYPE_KEYS_STR = [...ALERT_TYPE_KEYS] as string[]

export type AlertTypeKey = (typeof ALERT_TYPE_KEYS)[number]

const AlertSet = new Set(ALERT_TYPE_KEYS_STR)

export const isAlertTypeKey = (value: unknown): value is AlertTypeKey =>
    typeof value === 'string' && AlertSet.has(value)

export const parseAlertKey = (value: unknown): AlertTypeKey | null => {
    if (!isAlertTypeKey(value)) return null
    return value
}

export const REPORT_TYPES = ['yardreport', 'gatefeed'] as const
export type ReportType = (typeof REPORT_TYPES)[number]
